var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e1ecef;}.b{fill:#1d9ebd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-369 -1414)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 58.5,
    cy: 58.5,
    r: 58.5,
    transform: "translate(369 1414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5953.888,1291.511a21.638,21.638,0,1,0-33.033-2.935l-14.658,14.658,5.369,5.365,14.654-14.655A21.632,21.632,0,0,0,5953.888,1291.511Zm-25.264-5.335a14.091,14.091,0,1,1,19.926,0A14.09,14.09,0,0,1,5928.624,1286.176Z",
    transform: "translate(-5506.014 190.988)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.d9a70d669e1c63daa7091f95a68ee25b.svg";
export { ForwardRef as ReactComponent };